import React from "react";
import { motion } from "framer-motion";
import "./CoursespageSection.css";

import nttImage from "../../assets/Institute/Nursery-Teacher.JPG";
import mttImage from "../../assets/Institute/2151696381.jpg";
import pttImage from "../../assets/Institute/Primary-Teacher.JPG";

const CoursespageSection = () => {
  const courses = [
    {
      id: 1,
      title: "Nursery Teacher Training",
      subtitle: "NTT Course",
      description: "Teacher training for working in regular pre-schools.",
      image: nttImage,
      link: "/course/ntt-mttcourse",
    },
    {
      id: 2,
      title: "Montessori Teacher Training",
      subtitle: "MTT Course",
      description: "Teacher training for working in Montessori environments.",
      image: mttImage,
      link: "/course/ntt-mttcourse",
    },
    {
      id: 3,
      title: "Primary Teacher Training",
      subtitle: "PTT Course",
      description: "Teacher training for working in primary schools.",
      image: pttImage,
      link: "/course/ptt-course",
    },
  ];

  return (
    <section className="courses-section" id="courses">
      <motion.h2
        className="section-title-1"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        Courses
      </motion.h2>

      <motion.p
        className="section-subtitle-1"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.8 }}
      >
        Transform yourself into the best teacher you can be!
      </motion.p>

      <div className="courses-grid">
        {courses.map((course) => (
          <motion.div
            className="course-card"
            key={course.id}
            initial={{ opacity: 0, scale: 0.9 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: course.id * 0.2 }}
          >
            <div
              className="course-bg"
              style={{ backgroundImage: `url(${course.image})` }}
            >
              <img
                src={course.image}
                alt={`${course.title} at NIECCE`}
                title={`${course.title} at NIECCE`}
                className="course-bg-image"
              />
              <div className="course-overlay"></div>
              <div className="course-content">
                <h3>{course.title}</h3>
                <h4>{course.subtitle}</h4>
                <p style={{ color: "#fff" }}>
  {course.description}
</p>
                <a href={course.link} className="know-more">
                  Know More →
                </a>
              </div>
            </div>
          </motion.div>
        ))}
      </div>

      <motion.div
        className="btn-container"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <a href="/course/admission" className="enquiry-btn">
          Admission Enquiry →
        </a>
      </motion.div>
    </section>
  );
};

export default CoursespageSection;
